import React from 'react';
import { formatNumber } from 'utils';
import SKCard from '../../../../components/UI/SKCard';
import useService from '../../../../hooks/useService';
import classes from './styles.module.scss';
import { currencyValue } from 'utils';
import { StorageService } from 'service/Storage';

export default function UserStatistics({ data }) {
  return (
    <div className={classes.UserStatistics}>
      <SKCard className={classes.box}>
        <div className={classes.label}>
          {currencyValue(formatNumber(data.coinsEarned || 0))}
        </div>
        <div className={classes.value}>
          {StorageService.getCurrency() === 'inr'
            ? 'Rupees Earned'
            : 'Coins Earned'}
        </div>
      </SKCard>
      <SKCard className={classes.box}>
        <div className={classes.label}>
          ₹ {formatNumber(data.redeemedAmount || 0)}
        </div>
        <div className={classes.value}>Redeemed Amount</div>
      </SKCard>
      <SKCard className={classes.box}>
        <div className={classes.label}>{data.offerCompleted || 0}</div>
        <div className={classes.value}>Tasks Completed</div>
      </SKCard>
      <SKCard className={classes.box}>
        <div className={classes.label}>{data.referal || 0}</div>
        <div className={classes.value}>Invites</div>
      </SKCard>
    </div>
  );
}
